
import { InteractionRequiredAuthError } from "@azure/msal-browser"
import { useMsal } from "@azure/msal-react"
import React, { useEffect, useState } from "react"

import { loginRequest } from "./authConfig"
import { USER_SESSION_ID } from "./config/session-constants";
import { generateSessionId } from "./global";

// Define types for user data
interface UserData {
  displayName: string;
  id: string;
  mail: string;
  userPrincipalName: string;
}

const LoginPage: React.FC = () => {
  const { accounts, instance } = useMsal()
  const [userData, setUserData] = useState<UserData | null>(null)
  const [loading, setLoading] = useState<boolean>(true) // Add loading state
  useEffect(() => {
    if (accounts.length === 0) {
      login() 
    } 
  }, [accounts])

   // Handle redirect response after returning from ADFS
   useEffect(() => {
    instance.handleRedirectPromise()
      .then((response) => {
        if (response) console.log("Login Successful", response);
      })
      .catch((error) => {
        console.error("Redirect Error", error);
      });
  }, []);
  
  const login = () => {
    if (!localStorage.getItem(USER_SESSION_ID)) {
      localStorage.setItem(USER_SESSION_ID, generateSessionId())
    }
    instance.loginRedirect(loginRequest)
      .then((response:any) => {
        const accessToken = response.accessToken    
        if (accessToken) {
          localStorage.setItem('access_token', accessToken)
        }
      })
      .catch((error) => {
        console.error("Login error", error)
        setLoading(false) 
      })
  }

  const logout = () => {
    instance.logoutRedirect()
      .then(() => {
        console.log("Logged out successfully")
        setUserData(null) 
      })
      .catch((error) => {
        console.error("Logout error", error)
      })
  }

  return (
    <div>
    </div>
  )
}

export default LoginPage